// AddAppForm.js
import { Form, Button, message, Row, notification, Avatar } from "antd";
import { AppstoreOutlined, SafetyOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { REACT_APP_API_TENANTS_URL, ORG_ID, DOMAIN_ID } from "../../constants";
import {
  AppGeneralInfo,
  EntraConfig,
  OidcConfig,
  PrimaryAuth,
  SamlConfig,
  SecondaryAuthn,
} from "./AuthConfig/Authconfig";
import RenderIcon from "../../utils/renderImage";
function AddAppForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const isEdit = location.state?.isEdit;
  const existingApp = location.state?.app || {};
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [authMethod, setAuthMethod] = useState("SAML2"); // Default
  const firstLogin = localStorage.getItem("first_login");
  const [redirectUris, setRedirectUris] = useState([]);
  const [currentUri, setCurrentUri] = useState("");
  const primaryAuthValue = Form.useWatch("primaryAuth", form);
  const secondaryAuthValue = Form.useWatch("secondaryAuth", form);

  useEffect(() => {
    // console.log("TYPE of existingApp.scopes:", typeof existingApp.scopes);
    // console.log("VALUE of existingApp.redirectUris:", existingApp.redirectUris);
    // console.log("editApp redirectURIS:", existingApp.redirectUris);
    if (isEdit && existingApp) {
      form.setFieldsValue({ authMethod: existingApp?.authMethod || "SAML2" }); // default to SAML2 if undefined
      setAuthMethod(existingApp.authMethod);
      if (existingApp.authMethod === "OIDC") {
        let uris = [];
        if (typeof existingApp.redirectUris === "string") {
          // parse only if it's a valid JSON string
          if (
            existingApp.redirectUris.startsWith("[") &&
            existingApp.redirectUris.endsWith("]")
          ) {
            uris = JSON.parse(existingApp.redirectUris);
          } else {
            // handle single URI string case
            uris = [existingApp.redirectUris];
          }
        } else if (Array.isArray(existingApp.redirectUris)) {
          uris = existingApp.redirectUris;
        }
        console.log("uris", uris);

        form.setFieldsValue({
          appName: existingApp.appName,
          clientId: existingApp.clientId,
          clientSecret: existingApp.clientSecret,
          authUrl: existingApp.authUrl,
          description: existingApp.description,
          redirectUris: uris,
          scopes: existingApp.scopes
            ? JSON.parse(existingApp.scopes) // → ["openid"]
            : [],

          appLogo: undefined, // icon can't be directly set
          isActive: existingApp.status ?? true, // default to true if missing
        });
        setRedirectUris(uris);
        // if (uris.length > 0) {
        //   setCurrentUri(uris[0]);
        // }
      } else {
        // If SAML2
        form.setFieldsValue({
          appName: existingApp.appName,
          appUrl: existingApp.appUrl,
          loginUrl: existingApp.loginUrl,
          logoutUrl: existingApp.logoutUrl,
          metadataUrl: existingApp.metadataUrl,
          description: existingApp.description,
          appLogo: undefined,
          isActive: existingApp.status ?? true, // default to true if missing
        });
      }
    }
  }, [isEdit, existingApp, form]);

  // Pre-populate the Upload component with the previously saved icon
  // when editing an existing app. This ensures the uploaded file list
  // shows the existing icon so users can view or replace it.
  useEffect(() => {
    if (existingApp?.appLogo) {
      setFileList([
        {
          uid: "-1",
          name: `${existingApp.appName}icon.png`,
          status: "done",
          url: existingApp.appLogo,
        },
      ]);
    }
  }, [existingApp]);

  const handleSubmit = async (values) => {

    // if (loading) return;
    // // If first login, show special message & stop normal navigation
    // if (firstLogin) {
    //   message.success(
    //     "Default application created successfully. Please log out and log in again to check.",
    //   );
    //   navigate("/");
    //   localStorage.removeItem("first_login");
    //   return;
    // }
    // setLoading(true);

    // try {
    //   // Convert file to Base64 (if they accept Base64 as "URL")
    //   const file = values.appLogo?.originFileObj;
    //   const formData = new FormData();

    //   if (file) {
    //     // Convert file to Base64 (if they accept Base64 as "URL")
    //     formData.append("appLogo", file);
    //   } else {
    //     formData.append("appLogo", ""); // still append empty if required
    //   }

    //   const userIdRaw = localStorage.getItem("userId");
    //   const userId = userIdRaw ? Number(userIdRaw) : null;

    //   formData.append("orgId", String(ORG_ID()));
    //   formData.append("tenantId", String(DOMAIN_ID()));
    //   formData.append("userId", userId);
    //   formData.append("appName", values.appName);
    //   formData.append("description", values.description || "");
    //   formData.append("authMethod", authMethod); // e.g., "OIDC" or "SAML2"
    //   formData.append("clientId", authMethod === "OIDC" ? values.clientId : "");
    //   formData.append(
    //     "clientSecret",
    //     authMethod === "OIDC" ? values.clientSecret : "",
    //   );
    //   formData.append("appUrl", values.appUrl || "");
    //   formData.append("authUrl", authMethod === "OIDC" ? values.authUrl : "");
    //   formData.append("status", values.isActive ? "ACTIVE" : "INACTIVE");
    //   formData.append(
    //     "loginUrl",
    //     authMethod === "SAML2" ? values.loginUrl : "",
    //   );
    //   formData.append(
    //     "logoutUrl",
    //     authMethod === "SAML2" ? values.logoutUrl : "",
    //   );
    //   formData.append(
    //     "metadataUrl",
    //     authMethod === "SAML2" ? values.metadataUrl : "",
    //   );
    //   // Append redirectUris (send "" if none)
    //   formData.append(
    //     "redirectUris",
    //     JSON.stringify(
    //       values.redirectUris && values.redirectUris.length > 0
    //         ? values.redirectUris
    //         : [],
    //     ),
    //   );
    //   // Append scopes (send "" if none)
    //   formData.append(
    //     "scopes",
    //     JSON.stringify(
    //       values.scopes && values.scopes.length > 0 ? values.scopes : [],
    //     ),
    //   );

    //   if (isEdit) {
    //     formData.append("appId", existingApp.appId); // needed to identify for update
    //   }

    //   const endpoint = isEdit
    //     ? `${REACT_APP_API_TENANTS_URL}/updateApps` // update path
    //     : `${REACT_APP_API_TENANTS_URL}/apps`; // create path
    //   const res = await axios.post(endpoint, formData, {
    //     headers: {},
    //   });

    //   const data = res?.data;
    //   console.log("API Response Data:", data);

    //   form.resetFields();
    //   notification.success({
    //     message: "Success",
    //     description: isEdit
    //       ? "Application updated successfully"
    //       : "Application created successfully",
    //     placement: "top", // Change from "topRight" to "top"
    //     duration: 2,
    //   });

    //   setTimeout(() => {
    //     navigate("/pam/apps");
    //   }, 1000); // Delay navigation to allow the message to show for 2s
    // } catch (err) {
    //   console.error("Submit error:", err);
    //   alert(
    //     `Failed to create app: ${
    //       err instanceof Error ? err.message : "Unknown error"
    //     }`,
    //   );
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="top-0 left-0 right-0 bottom-0 z-50 flex flex-col items-start pt-2 ">
      <h1 className="font-semibold text-2xl text-left truncate flex-1 capitalize">
        <AppstoreOutlined className="mr-2" />
        {firstLogin
          ? "Create default application for SSO"
          : isEdit
            ? "Update Application"
            : "Add Application"}
      </h1>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="w-full  bg-white p-8 rounded-xl"
        initialValues={{ isActive: true, primaryAuth: "passwordLess" }}
      >
        {/* First Row: App Name & App URL */}
        <AppGeneralInfo
          fileList={fileList}
          setFileList={setFileList}
          existingApp={existingApp}
          form={form}
        />
        <section className="mt-3">
          <h2 className="text-lg font-semibold flex items-center gap-2 px-2 py-4">
            <span className="material-icons-round text-primary text-xl">
              <SafetyOutlined />
            </span>
            Authentication Factors
          </h2>

          <Row gutter={16}>
            <PrimaryAuth />
            <SecondaryAuthn form={form} />
          </Row>
        </section>

        {primaryAuthValue !== "password" &&
          primaryAuthValue !== "passwordLess" && (
            <section className="bg-white mt-6  border border-slate-200  rounded-xl shadow-sm overflow-hidden">
              <div className="p-6 border-b border-slate-100  flex items-center justify-between">
                <h2 className="text-lg font-semibold flex items-center gap-2">
                  <span className="material-icons-round text-primary text-xl">
                    <Avatar
                      className="text-[11px] text-blue-500 bg-white"
                      icon={RenderIcon("settings_ethernet")}
                    />
                  </span>
                  {primaryAuthValue} Configuration
                </h2>
                <span className="text-xs text-slate-400 italic">
                  Endpoints must be HTTPS
                </span>
              </div>
              <div className="p-6">
                <Row gutter={[32, 24]}>
                  {primaryAuthValue === "SAML2" && <SamlConfig />}

                  {primaryAuthValue === "OIDC" && (
                    <OidcConfig
                      currentUri={currentUri}
                      setCurrentUri={setCurrentUri}
                      form={form}
                      redirectUris={redirectUris}
                      setRedirectUris={setRedirectUris}
                    />
                  )}

                  {primaryAuthValue === "Entra" && <EntraConfig />}
                </Row>
              </div>
            </section>
          )}

        <Form.Item>
          <div className="flex justify-end gap-4 pt-6">
            <Button
              className="px-8 py-4 bg-white  border border-slate-200 text-slate-700  font-semibold rounded-xl hover:bg-slate-50 transition-colors shadow-sm"
              onClick={() => {
                if (firstLogin) {
                  localStorage.removeItem("first_login");
                  navigate("/"); // Skip → Home
                } else {
                  navigate("/pam/apps"); // Cancel → Apps
                }
              }}
            >
              {firstLogin ? "Skip" : "Back to List"}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="px-6 py-4 bg-primary hover:bg-blue-700 text-white font-bold rounded-xl shadow-xl shadow-blue-500/20 transition-all hover:scale-[1.02] active:scale-[0.98]"
            >
              {isEdit ? "Update Application" : "Create Application"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default AddAppForm;
